const zh_CN = {
    header001: '软件介绍',
    header002: '常见问题',
    header003: '版本信息',
    header004: '联系我们',
    header005: '功能说明',
    header006: '产品下载',
    title: '服务云',
    title_detail: '用互联网沟通传统行业',
    title_intro: '仅适用于windows',
    button_download: '立即下载',
    button_download_zhupy:'下载服务云组件',
    button_download_cloud:'下载服务云管家',
    banner_list_item0101: '专属专业',
    banner_list_item0102: '客服服务',
    banner_list_item0201: '实时简易',
    banner_list_item0202: '案件提交',
    banner_list_item0301: '高效专业',
    banner_list_item0302: '远程协助',
    banner_list_item0401: '丰富实用',
    banner_list_item0402: '插件工具',
    banner_list_item0501: '海量可查',
    banner_list_item0502: '知识宝库',
    more: '更多功能',
    service: '专属的客服服务',
    serviceText: '用互联网技术打通传统企业与客服人员的沟壑，资深的客服专员为您提供专属的客服服务。',
    submit: '实时案件提交',
    submitText: '实时在线提交案件，客服专员第一时间为您服务，并可实时追踪案件处理进度。',
    remote: '高效的远程协助',
    remoteText: '一键申请客户专员或MIS人员为您远程处理问题，为您提供高效的远程协助。',
    tools: '丰富的工具',
    toolsText: '官方提供工具，财务报表环境监测、成本对账、存货对账、效能排查等皆能轻松解决。 ',
    knowledge: '海量的知识库',
    knowledgeText: '海量的知识库，视频和图文详细指导您解决月结、LRP、盘点、IT等常见问题。',
    detail: '专业团队为您打造更方便的服务应用，通知中心、智能运维、鼎捷社区等更多功能已经开启',
    item01: '服务应用',
    item02: '通知中心',
    item03: '智慧运维',
    item04: '鼎捷社区',
    caption: '鼎捷服务云管家',
    captionTw: '鼎新服务云管家',
    headline: '用互联网沟通传统行业',

    newbie:'新手上路',
    cmp_handbook:'平台服务操作手册',
    own_application:'云管家应用',

    ver_info:'版本更新内容',
    ver_info_em:'当前暂无版本',
    ver_info_empty:'无版本更新内容',
    ver_info_add:'新增',
    ver_info_opt:'优化',
    ver_info_history:'历史版本',
    copy_right_number:'All rights reserved.沪ICP备10010150号-8',
    copy_right:' 鼎捷数智股份有限公司',
    dl_tel:'客服电话',
    fix_tel:'固定电话',
    service_tel:'客服热线',
    tech_tel:'技术支持热线',
    not_detail01:'哎呀！迷路了呐...',
    not_detail02:'休息一下回到首页吧',
    not_detail03:'回到首页',
    common_detail_title01:'开启云管家，闪退或者已停止工作',
    common_detail_title02:'客户注册云管家时，客服代号绑定错误，怎么办？',
    common_detail_title03:'IM聊天查看图片失败、透明',
    common_detail_title04:'云管家知识搜索视频点播放黑屏，看不了怎么办？',
    common_detail_title05:'开启云管家没有任何报错，但是未自动更新到最新版本',
    common_detail_title06:'远程接受之后崩溃，提示：已停止工作',
    common_detail_content01:'解决方案：1、添加兼容模式并以管理员身份运行！2、上述方法无果后，查看客户端.net framework版本是否为4.6 或者4.7。那么请卸载高版本的.net，然后安装4.0版本。若安装如下报错，请自行百度下载4.5版本安装后即可解决此问题。',
    common_detail_content02:'退出云管家--删除我的文档\Digiwin\SCP\Config文件夹下的SCP.desktop.shell.xml文件（如下图）--重新开启云管家--会出现客服代号绑定界面，重新绑定',
    common_detail_content03:'云管家IM系统查看图片默认驱动使用的是windows自带的照片查看器。最近wps升级，会篡改OS默认图片查看器为wps看图，才导致了IM聊天时查看图片失败。具体操作方法：打开控制面板--设置默认程序--选择照片查看器',
    common_detail_content04:'因为我们云管家播放视频是基于windows自带的Windows Media Player，那么播放视频出问题首先要验证windows media player是否可以正常工作。                    首先确保Windows启用Windows Media Player功能，并升级至Windows Media Player 11或以上版本',
    common_detail_content05:'原因：可能是因为打开的是云管家主程序SCP.Desktop.Shell.exe（如下图）。解决方法：右击红框exe--创建桌面快捷方式--添加命令行参数',
    common_detail_content06:'出现此现象一般是：远程相关文件（NNScreen.dll、SCPDesktopRDH.dll）被杀毒软件（360）误杀隔离导致',
    author:'作者',
    time:'时间',
    detail_list0101:'解决方案：',
    detail_list0102:'1、添加兼容模式并以管理员身份运行！',
    detail_list0103:'2、上述方法无果后，查看客户端.net framework版本是否为4.6 或者4.7。',
    detail_list0104:'那么请卸载高版本的.net，然后安装4.0版本。',
    detail_list0105:'dotNetFx40_Full_x86_x64.zip',
    detail_list0106:'若安装如下报错，请自行百度下载4.5版本安装后即可解决此问题。',
    detail_list0201:'答：退出云管家--删除我的文档\Digiwin\SCP\Config文件夹下的SCP.desktop.shell.xml文件（如下图）--重新开启云管家--会出现客服代号绑定界面，重新绑定',
    detail_list0301:'云管家IM系统查看图片默认驱动使用的是windows自带的照片查看器。',
    detail_list0302:'最近wps升级，会篡改OS默认图片查看器为wps看图，才导致了IM聊天时查看图片失败。',
    detail_list0303:'具体操作方法：打开控制面板--设置默认程序--选择照片查看器。',
    detail_list0401:'因为我们云管家播放视频是基于windows自带的Windows Media Player，那么播放视频出问题首先要验证windows media player是否可以正常工作。',
    detail_list0401:'首先确保Windows启用Windows Media Player功能，并升级至Windows Media Player 11或以上版本。',
    detail_list0402:'解决方案：',
    detail_list0403:'然后打开Windows Media Player播放器--文件--打开url--输入上面测试的url--确定（如下图）',
    detail_list0404:'那从上述方法测试下来，发现有的客户其实是网络问题导致播放视频需要缓冲...并不是视频无法播放，等一会就可以了。',
    detail_list0405:'请注意黑屏状况的客户播放器左上角是否显示的正在缓冲...？？',
    detail_list0501:'原因：可能是因为打开的是云管家主程序SCP.Desktop.Shell.exe（如下图）。',
    detail_list0502:'解决方法：右击红框exe--创建桌面快捷方式--添加命令行参数： -shortcut（注意空格，如下图）',
    detail_list0503:'注释：此命令是开启云管家时call起云管家自动更新程序SCP.Desktop.Update.exe',
    detail_list0504:'另一种方法：打开update文件夹，右击update.exe创建快捷方式即可。',
    detail_list0601:'出现此现象一般是：远程相关文件（NNScreen.dll、SCPDesktopRDH.dll）被杀毒软件（360）误杀隔离导致',
    detail_list0602:'可以打开360杀毒软件查看隔离区作如下操作：',
    detail_list0603:'选中 包含上面两个DLL文件的记录并恢复》》点选 将文件恢复到原来所在目录》》勾选 恢复后信任此文件，不再查杀》》恢复即可',
    detail_list0604:'另外这两个文件的路径：云管家：SCP\Runtime\Shared 易聊：SIM\Runtime',

    /* 功能说明文字 */
    introItem01:'安装说明',
    introItem02:'基本功能',
    introItem03:'连线精灵',
    introItem04:'案件管理',
    introItem05:'知识宝典',
    introItem06:'智能客服',
    introItem07:'资讯中心',
    introItem08:'系统运维',
    introItem09:'我的管家',
    
    introItem01_01:'鼎新服务云',
    introItem01_02:'贴近所想，拓展服务边界',
    introItem01_03:'我们用心为用户带来数位应用价值，在服务企业的全生命周期以「客户效益」为核心，为企业提供全程价值服务，并持续关注用户使用体验',
    introItem01_04:'2018年推出服务云管家，承载着为客户提供升级的服务体验的理念，服务云将翻转传统服务模式中的被动式，转为主动感知、及时反应用户端系统使用及系统运维上的状况，将众多服务工具化繁为简，突破时间、地域、人员的限制，服务上云的便捷应用让鼎新服务走在您需要之前',
    introItem01_05:'超越所想，所及无限',
    introItem01_06:'在实现客户应用价值的管理精进阶段中，装载服务云管家，透过服务云管家，透过云端互聊，AI智能引擎、大数据等新技术，以互联网思维模式整合多元应用，迭加智能工具与服务，制造出随选畅想的服务入口，协助运营指标布建监测、对应职能应用、培训课程、产品知识库...等，助力企业持续优化营运与转型创新。',

    introItem02_01:'安装鼎新服务云管家',
    introItem02_02:'在产品下载中，选择服务中心，在点选【立即下载】按钮进行下载安装档(SCP.Desktop.Setup.exe)，下载完成后请执行SCP.Desktop.Setup.exe进行安装。 ',
    introItem02_03:'开启鼎新客服连线精灵时，若出现下图讯息，按下',
    introItem02_04:'按钮，即会自动下载鼎新服务云管家安装程序进行安装',
    introItem02_05:'安装完后，于桌面会新增',
    introItem02_06:'的捷径。',
    introItem02_07:'登入/登出/关闭鼎新服务云管家',
    introItem02_08:'如何登入云管家',
    introItem02_09:'执行鼎新服务云管家后的画面如下图，必须登入系统才能使用云管家功能，请点选',
    introItem02_10:'【请登入】',
    introItem02_11:'进行用户的注册登入',
    introItem02_12:'按下',
    introItem02_13:'后出现【账号登入】',
    introItem02_14:'(此功能暂未开放)',
    introItem02_15:'已有鼎新用户服务平台的账号',
    introItem02_15_1:'请输入鼎新用户服务平台的登入E-Mail及密码，之后按下',
    introItem02_16:'【登入】',
    introItem02_17:'首次以鼎新用户服务平台账号登入时，需完善账号资讯。完善账号资讯之后，按下',
    introItem02_18:'【确定】',
    introItem02_19:'按钮即完成服务云账号绑定。往后即可直接以鼎新用户服务平台账号登入。',
    introItem02_20:'没有鼎新用户服务平台账号',
    introItem02_21:'请点选',
    introItem02_22:'【注册】',
    introItem02_23:'按钮，注册鼎新服务云管家账号',
    introItem02_24:'按下注册后，您将看到以下画面，请输入贵公司的',
    introItem02_25_1:'客服代号',
    introItem02_25_2:'与',
    introItem02_25_3:'客服密码',
    introItem02_26:'，且依画面提示输入您的个人资讯，并按下',
    introItem02_27:'， 您的账号即建立完成。',
    introItem02_28:'注:预设产品为定义登入云管家后所预设的产品线。',
    introItem02_29:'如何登出云管家',
    introItem02_30:'于云管家画面的右上方点选【≡】后再点选【账号登出】即可登出当前所登入的账号。',
    introItem02_31:'也可在云管家主画面的〝欢迎您使用鼎新云管家〞的地方按鼠标右键，即可出现',
    introItem02_32:'【登出】',
    introItem02_33:'字样，点选后即可登出当前所登入的账号。',
    introItem02_34:'如何关闭云管家',
    introItem02_35:'在作业系统工作列右下方的鼎新服务云管家图示，按鼠标右键，选择',
    introItem02_36:'即可关闭鼎新服务云管家',
    introItem02_add_36:'右上角菜单栏退出程序',
    introItem02_37:'于设定中心->主页，设定云管家关闭的模式',
    introItem02_37_1:'主页',
    introItem02_38:'隐藏到任务栏通知区域，不退出程序：',
    introItem02_39:'于云管家主画面按X关闭时，隐藏到任务栏通知区域',
    introItem02_40:'退出程序：',
    introItem02_41:'于云管家主画面按X关闭时，直接关闭云管家',
    
    introItem03_01:'依客户所购买的产品来显示，可用于不同产品问题的反应，例如，要发送WorkFlow ERP在线问题登录，就选WorkFlow ERP，要发送Smart ERP在线问题登录，就选Smart ERP。',
    introItem03_02:'切换产品线',
    introItem03_03:'可设定各项系统基本设定值',
    introItem03_04:'可设定是否于开机自动启动云管家',
    introItem03_04_1:'注:预设为开机自动启动云管家。',
    introItem03_05:'【主页】',
    introItem03_06:'设定云管家关闭的模式',
    introItem03_07:'【文件下载】',
    introItem03_08:'设定下载文件时预设的目录',
    introItem03_09:'【ERP管理】',
    introItem03_10:'设定ERP安装目录',
    introItem03_11:'【多产品管理】',
    introItem03_12:'如贵公司有购买多项鼎新产品，可于此设定每次登入云管家预设的产品线，提供该产品线相关的服务',
    introItem03_13:'【多语言管理】',
    introItem03_14:'设定云管家界面所要呈现的语言，可选择繁体及简体',
    introItem03_15:'【网络代理设置】',
    introItem03_16:'如果贵公司上网是透过Proxy网络代理上网时, 可在网络代理设置进行设定，可设定直接使用浏览器的设置，或是以手动方式自行设置',
    introItem03_17:'设定中心',
    introItem03_17_01:'个人中心',
    introItem03_18:'可查看个人注册时的相关资料、系统通知公告，以及相关活动所获得之奖券。',
    introItem03_19:'【我的资料】',
    introItem03_20:'注册时的基本资料，亦可点选',
    introItem03_20_1:'【编辑】做基本资料的修改。',
    introItem03_21:'【通知公告】',
    introItem03_22:'可查看系统发送的公告',
    introItem03_23:'【我的奖券】',
    introItem03_24:'个人于鼎新服务云管家相关活动所获得之奖券。可于此做奖券的兑换。',
    introItem03_25:'【他人奖券】',
    introItem03_26:'可查看贵公司其他同仁所获得之奖券。',
    
    introItem04_01:'如何使用连线精灵',
    introItem04_02:'用于提供使用者计算机，让鼎新计算机客服人员进行连线查看系统问题时使用。',
    introItem04_03:'[取得被控端ID] 按钮说明',
    introItem04_04:'按下按钮后，显示免责说明:',
    introItem04_05:'您按下 [接受] 后，会产生9码数字，如下图，再请您将9码数字通知鼎新数智人员',
    introItem04_06:'提醒: 当鼎新数智人员使用主控端连入时，您必须按下 [允许] 按钮才能连线，如下图',
    introItem04_07:'[取得被控端ID(无人值守)] 按钮说明:',
    introItem04_08:'此功能使用情境为：',
    introItem04_09:'当您可能不在座位上等待主控端连入，且您也同意鼎新/鼎捷人员可以连入时，可以使用无人值守功能。',
    introItem04_10:'无人值守功能为：当主控端连入时，如果您未在30秒内按下[允许]或[拒绝]，最后主控端可以自动连入被控端计算机。',
    introItem04_11:'使用无人值守模式时，系统会跳出免责声明，您必须按下[同意免责声明]才能使用',
    introItem04_12:'您按下 [接受] 后，会产生9码数字，如下图，再请您将9码数字通知鼎新数智人员',
    

    introItem05_01:'案件管理介绍',
    introItem05_02:'案件管理主要就是针对客户已经提交到客服中心的案件管理，主要是追踪案件的处理进度（处理中，还是已结案），查看案件的处理结果，以及历史案件的处理描述。',
    introItem05_03:'案件管理界面可以看出所选择的',
    introItem05_04:'【产品线】',
    introItem05_05:'正在处理中的案件数量以及已经解决的案件数量。点选处理中的案件数可以直接连结到案件一览里面的处理中的案件。',
    introItem05_06:'提交问题',
    introItem05_0602: '在云管家中的部份产品线为提供给使用者更便利的操作介面，把【提交问题】跟【智能客服】功能结合在一起，都整合【智能客服】功能中，单一入口让您点选更直觉、操作更便利。',
    introItem05_07:'选择所要提交问题的产品线',
    introItem05_08:'点选提交问题按钮',
    introItem05_09:'点选【提交问题】按钮后即可跳到案件提交的界面，供您反应您的问题。',
    introItem05_10:'输入所要反应的使用问题，并提交问题',
    introItem05_11:'增加附件',
    introItem05_12:'点选',
    introItem05_13:'【选择档案】',
    introItem05_14:'可以选择要上传的附件。点选',
    introItem05_14_1:'【截图】',
    introItem05_14_2:'可开启截图功能，截图后会自动成为附件。',
    introItem05_15:'联系方式：',
    introItem05_16:'提供本次反应问题者的联系方式，只能选择一位。可利用增加、编辑、删除等功能来进行维护。',
    introItem05_17:'副本寄送：',
    introItem05_18:'将本次反应的问题内容，同时寄送给副本收件人员。于提交问题后，该副本寄送名单，会储存在历史记录，以供下回快速点选加入。',
    introItem05_19:'案件提交后，系统会发送问题提交成功的MAIL给联系人及副本寄送人',
    introItem05_19_1:'注：案件提交的功能也可以从【我的管家】页面的『案件提交』来使用',
    introItem05_19_2: '在云管家中的部份产品线为提供使用者更便利的操作介面，云管家中的部分产品线已将【提交问题】与【智能客服】功能整合在【智能客服】中，通过单一入口让点选更直觉、操作更便利。',
    introItem05_20:'案件一览',
    introItem05_21:'点',
    introItem05_22:'按钮后，就可以看到您所有案件的详情。其中包含处理中及近三个月已结案的案件。',
    introItem05_23:'注：新注册的云管家用户，如果以前曾有反应案件到客服中心，要到隔天才会看到这些案件',
    introItem05_24:'点击进阶搜索可以选择细化的搜索条目',
    introItem05_25:'点选某一笔案件，再点下一个',
    introItem05_26:'【操作】',
    introItem05_27:'栏位的按钮，可查看目前案件的详情及进度',
    introItem05_28:'可依需求做一般的问题描述查询或进阶查询，亦可将目前列表中所查看到的案件详情资讯汇出。',
    
    
    introItem06_01:'知识宝典介绍',
    introItem06_02:'知识宝典是一种类似Google的搜寻引擎，可以透过关键字的形式搜索知识库，通过检索关键字可以找到相关问题的解决方案。解决方案包含文字形式、图文形式，以及影音形式。知识宝典裡面的内容我们会定期更新完善，内容会越来越丰富。并且提供收藏功能，对您感兴趣的内容点选收藏后，方便又快捷找到您感兴趣的内容。还提供知识分享的功能，把您认为有用的知识分享给其他人。',
    introItem06_03:'【模糊搜寻】',
    introItem06_04:'找出与输入的关键字完全或部分符合的内容',
    introItem06_05:'【关键字搜寻】',
    introItem06_06:'找出与输入的关键字完全符合的内容',
    introItem06_0502: '【影音推荐】',
    introItem06_0602: '显示该产品线目前推荐的影音清单',
    introItem06_07:'【最新上架】',
    introItem06_08:'一个月内该产品线发佈的知识库数量统计',
    introItem06_09:'【累计上架】',
    introItem06_10:'该产品线所有发佈的知识库数量统计',
    introItem06_11:'【累计搜寻】',
    introItem06_12:'所有搜寻次数的数量统计',
    introItem06_13:'【累计查看】',
    introItem06_14:'搜寻到资料后，所有查看内容次数的数量统计',
    introItem06_15:'【最新影音知识点】',
    introItem06_16:'显示该产品线目前最新上架的影音清单',
    introItem06_17:'如何搜寻知识库',
    introItem06_18:'选择所要搜寻的产品别',
    introItem06_19:'输入搜寻的条件',
    introItem06_20:'例如：想要搜寻有关于成本的影音知识库，先点选',
    introItem06_21:'，然后在搜寻栏内输入成本，再按下搜寻按钮，即可搜寻有关成本的影音知识库内容。',
    introItem06_22:'注：搜寻知识库的功能也可以从',
    introItem06_23:'页面的',
    introItem06_23_1:'『知识搜寻』',
    introItem06_23_2:'来使用',
    introItem06_24:'如何收藏知识库',
    introItem06_25:'在所要收藏的知识库内容右上方，点选',
    introItem06_26:'，即可将此则知识库内容进行收藏。',
    introItem06_27:'如何查看已收藏的知识库',
    introItem06_28:'，即可查看已收藏的知识库内容',
    introItem06_29:'如何分享知识库',
    introItem06_30:'可以将您认为有用的内容分享给其他同事，点选【分享】，接着点选【复制链接】',
    introItem06_31:'将系统复制在剪贴簿里的连结，以MAIL或是通讯软件将该连结提供给您的同事。',
    introItem06_32:'将复制在剪贴簿的链接传送给您要分享的对象，当对方复制并登入鼎新服务云管家之后，就会出现如下所示对话视窗，点选',
    introItem06_33:'【查看详情】',
    introItem06_34:'按钮即可。',
    
    introItem07_01:'智能客服介绍',
    introItem07_02:'可利用此项服务，透过文字方式，实时与机器人询问系统操作问题，或与在线文字客服人员进行交谈解决系统使用问题。',
    introItem07_03:'如何使用智能客服',
    introItem07_04:'选择产品别',
    introItem07_05:'(产用产品线：Workflow ERP、Smart ERP、CosmosERP/POS)',
    introItem07_06:'按钮',
    introItem07_07:'进入后可与AI智能客服对谈询问系统问题，也可以点选视窗中的知识宝库，学习相关系统知识。',
    introItem07_0702:'当AI智能客服不了解您询问的问题时，会出现您可以进行案件提交或连线真人文字客服（上班期间）的选项。',
    introItem07_08:'点选右上方',
    introItem07_09:'【连线真人文字客服】',
    introItem07_10:'按钮，可与真人文字客服对谈',
    introItem08_01:'资讯中心介绍',
    introItem08_02:'【资讯中心】提供串连到鼎新数智用户服务各项功能及工具下载。',
    introItem08_03:'【合约资讯】',
    introItem08_04:'显示合约购买模组或各项服务使用说明及使用状况。',
    introItem08_05:'【修正程式下载】',
    introItem08_06:'此功能为授权给鼎新合约客户使用，供下载取得最新修正程式。( 注：部份产品未提供此功能)',
    introItem08_07:'【系统文件下载】',
    introItem08_08:'系统文件区，提供客户经常性来电索取之文件，您可以透过此处直接下载。',
    introItem08_09:'【知识学院】',
    introItem08_10:'您可以透过此功能查看鼎新台湾各区分公司全年度对外公开活动及课程行事历，点选单一课程可以查看详细活动内容及课程明细。',
    introItem08_11:'【订阅电子报】',
    introItem08_12:'提供鼎新最新消息发佈、各职能资讯及系统应用资讯。',
    introItem08_13:'【委托个案】',
    introItem08_14:'随时提供鼎新为您客製化修改的程式内容及完成进度查询。',
    introItem08_15:'【产品功能文件下载】',
    introItem08_16:'此功能授权给鼎新合约客户下载使用，想知道最新产品功能及作业程序，建议您可以下载参考文件。',
    introItem08_1502:'【出货文件下载】',
    introItem08_1602:'出货文件区，提供出货文件可供客户下载。',
    introItem08_17:'【企业学习网】',
    introItem08_18:'串连到鼎新企业学习网站。',
    introItem08_19:'【用户学习网】',
    introItem08_20:'串连到鼎新用户学习网站。',
    introItem08_21:'注：详细鼎新用户服务平台使用说明点此参考。',
    introItem08_22:'点此参考。',
    introItem09_001:'系统运维介绍',
    introItem09_01:'整合鼎新数智Ai智管家智能管理平台，显示异常服务器数量及预警数量，您可以点选[Ai智管家]按钮开启Ai智管家智能管理平台。Ai智管家通过AI技术协助企业简化资讯日常维运，整合管理资讯设备，24小时监控，异常即时告警，帮助管理人员快速应对，降低成本并避免营运中断。',
    introItem10_01:'我的管家是登入鼎新服务云管家后的首页，其中包含了客服专员、知识搜寻、案件提交、文字客服、智慧客服等功能。',
    introItem10_01_01:'其中【未读公告】，可查看服务云管家所发送的公告通知。【处理中案件】可查看反应客服处理中的案件。而画面左上角的跑马灯则是显示最新的公告。',
    introItem10_02:'知识搜寻',
    introItem10_02_01:'可以透过关键字的形式搜寻知识库，通过检索关键字可以找到相关问题的解决方案。解决方案包含文字形式、图文形式，以及影音形式。详细使用可参考',
    introItem10_02_02:'知识宝典',
    introItem10_02_03:'里的说明。',
    introItem10_03:'选择所要搜寻的产品线',
    introItem10_04:'点选知识搜寻按钮',
    introItem10_05:'输入搜寻的条件',
    introItem10_06:'例如：想要搜寻有关于成本的知识库，搜寻栏内输入成本，再按下搜索按钮，即可搜寻有关成本的知识库内容。',
    introItem10_07:'案件提交',
    introItem10_08:'可以提交问题到客服中心，由客服人员为您回覆说明。详细使用可参考',
    introItem10_08_1:'案件管理',
    introItem10_08_2:'点选【案件提交】后即可跳到案件提交的界面。',
    
    languageCN:'简体中文',
    languageTW:'繁體中文',
    languageEN:'English',
    languageTHAI:'ไทย',
    languageVN:'Tiếng việt nam',
    service:'服务',
    cloud:'云',
    manager:'管家',
    p_detail_01:'我们用心为用户带来数位应用价值，在服务企业的全生命周期，以「',
    p_detail_02:'客户效益',
    p_detail_03:'」为核心，为企业提供全程价值服务，并持续关注用户使用体验。',
    p_detail_04:'默认服务中心',
    p_detail_05:'大陆',

    dl:'大陆',
    tw:'台湾',
    yn:'越南',
    mlxy:'马来西亚',
    tg:'泰国',
    english:'English',

    serviceCloud:'服务云管家',
    ITCloud: '鼎捷智管家',
    ITCloud_TW: 'Ai智管家',
    ITCloud_CN: '鼎捷智管家',
    message01:'免费为鼎新鼎捷客户提供2台主机预警服务',
    message02:'提供全面的巡检服务',
    message03:'协助你进行IT运维，提高效率',
    message04:'IT资产管理',
    message05:'助你了解公司内主机的硬件、软件信息， 让你的管理更轻松',
    message06:'运维报告',
    message07:'鼎新专业的运维工程师，为你提供本公司的运维分析建议，让你的运维更加稳健',
    scpinstallmsg:"请先安裝鼎捷云管家或升级至最新版本！",

    policyTitle:'鼎捷隐私政策',
    policyContent:'欢迎您使用鼎捷产品及服务！',
    policyContent_1:'鼎捷数智股份有限公司及其关联公司（以下简称“鼎捷”或“我们”）为保护您的用户信息安全可控，将按照适用的法律法规要求，对您的用户信息采取安全保护措施。因此，鼎捷制定本《鼎捷隐私政策》（以下简称“隐私权政策”）并提醒您：在使用鼎捷的各项服务前，请您务必仔细阅读并透彻理解本隐私权政策，在确认充分理解并同意后方使用相关产品和服务。一旦您开始使用鼎捷的各项产品或服务，将被视为对本隐私权政策的接受和认可。',
    policyContent_2:'鼎捷（以下或称为“我们”）尊重并保护用户信息，并且将以高度勤勉和审慎的义务对待这些信息。在您使用了鼎捷提供的服务时，我们将按照本隐私权政策收集、处理及披露您的信息。我们希望通过本隐私权政策向您清晰地介绍我们对您信息的处理方式，因此我们建议您完整地阅读本隐私权政策，以帮助您了解维护自己隐私权的方式。',
    policyContent_3:'本隐私权政策主要包括以下内容：',
    policyContent_31:'一、定义',
    policyContent_32:'二、适用范围',
    policyContent_33:'三、用户个人信息的收集与使用',
    policyContent_34:'四、用户个人信息共享、转让、公开披露的方式',
    policyContent_35:'五、用户业务数据和公开信息',
    policyContent_36:'六、用户个人信息的查询、更正与删除五、用户业务数据和公开信息',
    policyContent_37:'七、cookie和同类技术的使用方式',
    policyContent_38:'八、用户个人信息的安全保护措施',
    policyContent_39:'九、我们如何存储您的个人信息',
    policyContent_310:'十、未成年人用户个人信息的特别约定',
    policyContent_311:'十一、用户其他权利条款',
    policyContent_312:'十二、隐私权政策的更新',
    policyContent_313:'十三、我们的联系方式',
    policyItem01:'一、定义',
    policyItem01_1:'1.1. 鼎捷网站：指鼎捷官网（域名为：digiwincloud.com.cn）及相应的客户端（即APP，如有）。',
    policyItem01_2:'1.2. 鼎捷：除非另有约定，指鼎捷网站的运营者鼎捷数智股份有限公司及其关联公司。',
    policyItem01_3:'1.3. 鼎捷数智关联公司：指鼎捷数智股份有限公司最新上市年报披露的关联公司，具体详见上海证券交易所官方网站。',
    policyItem01_4:'1.4. 鼎捷服务：涵盖鼎捷入口产品、鼎捷平台产品、鼎捷生态服务以及鼎捷云服务',
    policyItem01_5:'1.5. 用户：指购买鼎捷的产品或服务并接受相关技术及网络支持服务的个人、企业、公司、事业单位等其他依据中华人民共和国法律享有民事权利 并能独立承担民事义务的组织。',
    policyItem01_6:'1.6. 用户个人信息：用户个人信息是指用户向鼎捷提交的或者鼎捷收集的用户信息，上述信息可以电子或者其他方式记录，并可单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况。',
    policyItem01_7:'1.7. 个人敏感信息：是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。鼎捷服务的个人敏感信息包括身份证件号码、手机号码、个人生物识别信息、银行账号、财产信息、交易信息、14岁以下（含）儿童的个人信息等。',
    policyItem01_8:'1.8. 业务数据：不同于用户信息，是指鼎捷的用户利用鼎捷的服务上传、下载、分发等通过鼎捷的技术服务处理的数据',
    policyItem01_9:'1.9. 收集：指鼎捷获得对用户的个人信息的控制权的行为，包括由用户主动提供、通过与用户交互或记录用户行为等自动采集，以及通过共享、转让、搜集公开信息间接获取等方式。',
    policyItem02:'二、 适用范围',
    policyItem02_1:'2.1. 本隐私权政策适用于鼎捷提供的所有鼎捷服务，包括但不限于鼎捷基于互联网技术建立且享有著作权的公有云系统服务平台以及基于该云平台提供的各类企业互联网应用服务，及上述服务涉及的移动客户端（即APP，如有）。',
    policyItem02_2:'2.2. 本隐私权政策不适用于其他第三方向您提供的服务。包括鼎捷市场上入驻的第三方生态伙伴向您提供的服务以及鼎捷市场售卖的融合型生态产品。',
    policyItem03:'三、 用户个人信息收集与使用',
    policyItem03_0:'在您使用我们的产品及服务时，我们需要收集和使用您的个人信息包括如下两种：',
    policyItem03_01:'（1） 为实现向您提供我们产品及服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品及服务；',
    policyItem03_02:'（2） 为实现向您提供我们产品及服务的附加功能，您可选择授权我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，但并不会影响您正常使用我们产品及服务的基本功能。',
    policyItem03_1:'3.1 我们使用您的个人信息的目的 :',
    policyItem03_11:'3.1.1. 为了向您提供服务，我们会向您发送信息、通知或与您进行业务沟通，包括但不限于为保证服务完成所必须的验证码、使用服务时所必要的推送通知；',
    policyItem03_12:'3.1.2. 为了维护、改进服务，向您提供更符合您个性化需求的信息展示，我们可能将来自鼎捷某项服务的个人信息与来自其他类型云服务的信息结合起来进行用户画像，向您展示、推送信息和可能的商业广告，包括但不限于关于鼎捷产品的新闻以及市场活动及优惠促销信息、鼎捷合作第三方的推广信息，或其他您可能感兴趣的内容；',
    policyItem03_13:'3.1.3. 我们可能以您的用户个人信息统计数据为基础，设计、开发、推广全新的产品及服务；我们会对我们的服务使用情况进行统计，并可能会与公众或第三方分享这些统计信息，但这些统计信息在分享前会去除您的身份标识并做匿名化处理；',
    policyItem03_14:'3.1.4. 为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，确保操作环境安全与识别账号异常状态，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或鼎捷相关协议、规则的情况，我们可能使用您的用户个人信息整合设备信息、有关网络日志以及我们关联公司、合作伙伴合法分享的信息，来判断您账户及交易风险、进行身份验证、安全事件的检测及防范，并依法采取必要的记录、审计、分析、处置措施；',
    policyItem03_15:'3.1.5. 如我们超出本款约定使用您的用户个人信息，或者在超出具有合理范围使用您的用户个人信息前，我们会再次向您告知并征得您的明示同意。',
    policyItem03_16:'如果您使用的是移动客户端，我们向您提供您所选择使用的服务，或者保证服务的质量和体验，可能需要您授权开启操作系统权限。如果您不同意授权App/网站获取相关操作系统权限，不会影响您使用我们提供的鼎捷数字化办公、沟通与协同等基本服务基本业务功能，但您可能无法获得附加服务给您带来的用户体验。',
    policyItem03_2:'3.2 我们收集您的个人信息的范围',
    policyItem03_20:'您的个人信息是指单独使用或结合其他信息使用时能够确定您个人身份的信息。您或您所在的企业组织用户注册、使用我们的网站、产品或服务时， 我们会向其收集您的必要个人信息，具体如下：',
    policyItem03_21:'3.2.1 注册账户时收集的信息',
    policyItem03_210:'您在注册鼎捷账户时，我们会收集您的如下信息：',
    policyItem03_211:'3.2.1.1. 注册成为鼎捷个人用户： 如您注册成为鼎捷个人用户，以便我们为您提供基础的鼎捷服务，我们需要收集您的手机号码及短信验证码以 注册并创建鼎捷账号，否则您将不能使用上述鼎捷服务。',
    policyItem03_212:'3.2.1.2. 注册成为鼎捷企业/组织用户： 为注册成为鼎捷企业组织用户，以便我们基于您所在企业组织的雇佣及管理行为提供鼎捷服务。 您需要提供您的企业/组织名称创建鼎捷企业/组织账号，否则您将不能基于企业组织管理行为使用鼎捷服务。注册成为鼎捷企业组织用户后， 您须进一步提供企业/组织所在地、行业类型、人员规模信息。',
    policyItem03_22:'3.2.2 使用服务时收集的信息',
    policyItem03_220:'您在使用鼎捷服务时，根据您使用具体产品的不同，我们收集您的信息也有所差异。',
    policyItem03_221:'您理解并同意，如您作为企业组织管理员选择开通、管理鼎捷服务的，您所在企业组织用户的个人用户使用鼎捷服务相关功能/ 应用过程中可能会提交或产生相应的信息和数据（下称“企业控制数据”）。您确认并知晓，企业组织用户为上述企业控制数据的控制者， 鼎捷仅根据企业组织用户管理员选择开通、管理和使用上述应用服务处理您的个人信息/数据。企业组织用户上传上述个人用户的个人信息之前， 应确保已经事先获得上述个人用户的明确同意，并仅限收集实现企业运营及管理目的所必需的个人用户的个人信息， 并已充分告知上述个人用户有关相关数据收集的目的、范围及使用方式等。',
    policyItem03_3:'3.3 我们收集您的个人信息的方式',
    policyItem03_31:'3.3.1. 我们将收集和储存在您注册、登录、浏览鼎捷产品及/或使用鼎捷服务时主动向鼎捷提供的个人信息；',
    policyItem03_32:'3.3.2. 我们将收集和储存鼎捷在向您提供鼎捷服务的过程中记录的与您有关的个人信息；',
    policyItem03_33:'3.3.3. 我们将收集和储存您通过鼎捷的客服人员及/或其他渠道主动提交或反馈的个人信息；',
    policyItem03_34:'3.3.4. 我们向关联公司、商业合作伙伴及第三方独立资料来源，收集和储存其合法获得的与您有关的个人信息；',
    policyItem03_35:'3.3.5. 我们可能向依法设立的征信机构查询您的相关信用信息，如信用分、信用报告等。',
    policyItem04:'四、用户个人信息共享、转让、公开披露的方式',
    policyItem04_1:'我们不会与其他组织和个人共享您的用户信息，但以下情况除外：',
    policyItem04_11:'4.1.1. 在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的用户信息；',
    policyItem04_12:'4.1.2. 在法定情形下的共享：我们可能会根据法律法规规定、诉讼、仲裁解决需要，或按行政、司法机关依法提出的要求，对外共享您的用户信息；',
    policyItem04_13:'4.1.3. 与关联公司间共享：为便于我们基于鼎捷向您提供产品和服务，推荐您可能感兴趣的信息，识别账号异常，保护鼎捷关联公司或其他用户或公众的 人身财产安全免遭侵害，经您的明确同意，您的用户个人信息可能会与我们的关联公司共享。',
    policyItem04_14:'4.1.4. 与授权合作伙伴共享：如果您通过鼎捷使用的某些服务是由鼎捷的供应商、 合作伙伴或入驻鼎捷市场的第三方授权合作伙伴提供的，经您的明确同意，鼎捷将与其共享向您提供相应产品及服务所必需的个人信息； 此外，为了与上述第三方授权合作伙伴共同开展市场推广活动，经您的明确同意，鼎捷可能与其共享开展活动所必需的以及在活动过程中 产生的您的相关个人信息；',
    policyItem04_15:'4.1.5. 对我们与之共享用户信息的公司、组织和个人，我们会与其签署严格的保密协议以及信息保护约定，要求他们按照我们的说明、本隐私权政策以及 其他任何相关的保密和安全措施来处理用户信息。',
    policyItem04_2:'4.2. 转让',
    policyItem04_20:'我们不会将您的用户信息转让给任何公司、组织和个人，但以下情况除外：',
    policyItem04_21:'4.2.1. 在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的用户信息；',
    policyItem04_22:'4.2.2. 在鼎捷与其他法律主体者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到用户信息转让， 我们会要求新的持有您用户信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。',
    policyItem04_3:'4.3. 公开披露',
    policyItem04_30:'在对您的任何个人信息进行披露之前，我们会咨询您，并接受由您通过合同形式约定的个人信息披露内容。除了您的明确授权和法律法规要求， 我们不会向其他人授权您的个人信息，我们仅会在以下情况下，公开披露您的用户个人信息：',
    policyItem04_31:'4.3.1. 获得您明确同意或基于您的主动选择，我们可能会公开披露您的用户信息；',
    policyItem04_32:'4.3.2. 或为保护鼎捷及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据适用的法律或鼎捷平台相关协议、规则披露关于您的用户信息。',
    policyItem04_4:'4.4. 共享、转让、公开披露用户信息时事先征得授权同意的例外',
    policyItem04_41:'4.4.1. 与国家安全、国防安全有关的；',
    policyItem04_42:'4.4.2. 与公共安全、公共卫生、重大公共利益有关的；',
    policyItem04_43:'4.4.3. 与犯罪侦查、起诉、审判和判决执行等有关的；',
    policyItem04_44:'4.4.4. 出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；',
    policyItem04_45:'4.4.5. 您自行向社会公众公开的个人信息；',
    policyItem04_46:'4.4.6. 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。',
    policyItem05:'五、用户业务数据和公开信息',
    policyItem05_0:'不同于您的用户信息，对于用户业务数据和公开信息，鼎捷将按如下方式处理：',
    policyItem05_1:'5.1 用户业务数据',
    policyItem05_11:'5.1.1. 您通过鼎捷提供的服务，加工、存储、上传、下载、分发以及通过其他方式处理的数据，均为您的用户业务数据， 您完全拥有您的用户业务数据。鼎捷作为企业云服务提供商，我们只会严格执行您的指示处理您的业务数据， 除按与您协商一致或执行明确的法律法规要求外，不对您的业务数据进行任何非授权的使用或披露。',
    policyItem05_12:'5.1.2. 您应对您的用户业务数据来源及内容负责，鼎捷提示您谨慎判断数据来源及内容的合法性。因您的用户业务数据内容违反法律法规、 部门规章或国家政策而造成的全部结果及责任均由您自行承担。',
    policyItem05_13:'5.1.3. 为了优化服务质量和向您提供新的产品与服务，鼎捷会收集您于鼎捷相关产品内的交易数据、交易过程与订单信息进行数据分析 并将上述业务数据（敏感信息除外）共享给鼎捷关联公司。',
    policyItem05_2:'5.2 公开信息',
    policyItem05_21:'5.2.1. 公开信息是指您公开分享的任何信息，任何人都可以在使用和未使用鼎捷网站服务期间查看或访问这些信息。',
    policyItem05_22:'5.2.2. 为使用鼎捷服务，可能存在您必须公开分享的信息。例如鼎捷云市场为构建诚信交易环境，您的信用评价信息（星级、客户评价） 需要被公开分享。若您是ISV伙伴（卖家），您应当根据适用的法律法规和鼎捷云市场规则的要求，公开分享企业或者自然人经营者的相关信息。',
    policyItem06:'六、用户个人信息的查询、更正与删除',
    policyItem06_1:'6.1 您可以查看您提供给鼎捷的注册信息及使用鼎捷云平台过程中产生的其他信息。如果您希望删除或更正您的信息， 请通过鼎捷的客户隐私专用邮箱 （privacy@digiwincloud.com） 与我们联系。在您申请注销或删除帐号之后我们会在30个工作日内完成。',
    policyItem06_2:'6.2 对于鼎捷收集的个人信息，如存在下述情形，您可以联系鼎捷客服人员要求删除您的账户，或移除特定个人信息：',
    policyItem06_21:'6.2.1. 您认为我们不再有必要持有您的个人信息；',
    policyItem06_22:'6.2.2. 我们曾取得您的同意来处理个人信息，且您事后收回同意（且我们并无其他理由处理该个人信息）；',
    policyItem06_23:'6.2.3. 您认为我们以非法方式处理您的个人信息；',
    policyItem06_24:'6.2.4. 在我们收集该个人信息时，您正值或未满 16岁，且我们能够验证您的年龄。',
    policyItem06_3:'在您主动注销鼎捷个人账户之后，我们将停止为您提供鼎捷服务，并根据适用法律的要求对您的个人信息做匿名化处理。',
    policyItem06_4:'当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息， 我们将安全地存储您的个人信息并将其与其他信息分别存储，直到备份可以清除或实现匿名。',
    policyItem07:'七、cookie和同类技术的使用方式',
    policyItem07_1:'7.1. 我们会在鼎捷服务上使用并允许其他特定公司使用 Cookie、网络信标以及其他同类技术。此举是为了了解您对鼎捷服务的使用情况，改善您的用户体验， 并实现个性化的功能和内容，优化我们的广告和营销，以及让第三方广告公司协助我们通过互联网提供符合您兴趣的广告。',
    policyItem07_2:'7.2. Cookie是在您访问网站时下载到您设备上的包含少量信息的文本文件。通过这些Cookie，我们能记住您在鼎捷网站上进行的选择，并提供增强的、 更个性化的功能。同时，我们使用自身的 Cookie 和/或第三方Cookie及其他标识符（如网络信标）查看您如何使用我们的网站和服务，以便增强其性能， 并根据您的偏好选择对其进行开发。此外，我们还允许数据提供商使用Cookie或其他同类技术，帮助我们提供内容和广告，并评估我们广告活动的效果。',
    policyItem07_3:'7.3. 您可根据自己的偏好管理Cookie，您也可以清除设备上保存的所有 Cookie。大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做， 则需要在每一次访问鼎捷网站时更改用户设置。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。',
    policyItem07_4:'7.4. 除 Cookie 外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的 地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到 网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪， 则可以随时从我们的寄信名单中退订。',
    policyItem08:'八、用户个人信息的安全保护措施',
    policyItem08_1:'鼎捷及鼎捷的关联公司将采用严格的安全制度以及行业通行的安全技术和程序来确保您的个人信息不被丢失、泄露、毁损或滥用。鼎捷的供应商、 合作伙伴或入驻鼎捷平台的第三方ISV伙伴将受到保密协议的约束，同时还将受到数据信息的权限控制和操作监控。',
    policyItem09:'九、我们如何存储您的个人信息',
    policyItem09_1:'9.1. 存储地点 我们将在中华人民共和国境内外运营的鼎捷服务中收集和产生的个人信息存储在中华人民共和国境内。',
    policyItem09_2:'9.2. 存储期限： 我们会采取合理可行的措施存储您的个人资讯，尽力避免收集无关的个人资讯。 我们只会在在限于达成本政策所述目的所需的期限以及所适用法律法规所要求的期限内保留您的个人资讯。 鼎捷将依据《中华人民共和国网络安全法》的要求，就您使用鼎捷应用服务留存相关的网络日志不少于六个月。',
    policyItem10:'十、未成年人用户信息的特别约定',
    policyItem10_1:'10.1. 我们主要面向成人提供产品和服务。如您为未成年人，我们要求您请您的父母或监护人仔细阅读本隐私权政策， 并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。',
    policyItem10_2:'10.2. 对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、 父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。',
    policyItem11:'十一、用户其他权利条款',
    policyItem11_1:'11.1 个人信息的查询与修正',
    policyItem11_11:'经您要求，鼎捷会告知您我们是否收集了您的个人信息；如确有收集行为，则您也有权得知我们收集您的个人信息种类、使用方式与共享对象。 您有权随时登入您的鼎捷网站账户来查询并修正您的个人信息。在满足法律法规要求的最短保存期限要求的情况下， 我们将对您的个人信息进行删除或匿名化处理。在上述法律法规要求的最短保存期限内，我们将不再对您的个人信息进行商业化使用。',
    policyItem11_2:'11.2 个人信息仅限存储目的而处理',
    policyItem11_20:'对于鼎捷收集的个人信息，如存在下述情形，你有权请求鼎捷除存储目的外将停止处理该等个人信息：',
    policyItem11_21:'11.2.1 您认为该个人信息不正确（限于我们验证其是否正确之期间内）；',
    policyItem11_22:'11.2.2 处理该个人信息为非法，我们因此希望消除该个人信息，但您希望我们保留该信息并仅存储之',
    policyItem11_23:'11.2.3 鼎捷再无必要处理该个人信息并因此希望删除该个人信息，但您要求存储该信息，以便提出、主张或对抗法律救济。',
    policyItem11_3:'11.3 个人信息的可携带性',
    policyItem11_31:'对于鼎捷收集的个人信息，您有权取得副本。您有权以结构化、通用且机器可读之格式获得此信息。您也有权要求鼎捷将该个人 信息移转给其他人或行使导出数据的权利。若您希望鼎捷将上述个人信息移转给第三方，请确保您会详述该第三方。如您要行使以上权利， 请通过鼎捷的客户隐私专用邮箱 （privacy@digiwincloud.com） 与我们联系。请注意，鼎捷仅在技术上可行的情况下才能转移信息。 一旦该第三方接收该个人信息后，对该信息之安全与否或对其处理方式，鼎捷概不负责。若提供特定个人信息会影响他人权利， 则我们可能无法将之提供给您（例如，提供该个人信息会揭露他人信息、鼎捷或任何第三方的商业秘密或知识产权信息）。',
    policyItem11_4:'11.4 个人信息收集和使用的拒绝权',
    policyItem11_41:'如您之前已同意鼎捷收集并使用您的个人信息，在适用法律与规定的允许范围内，您可以撤回先前授予给我们的任何同意并有权拒绝我们使用该等个人信息。',
    policyItem12:'十二、隐私权政策的更新',
    policyItem12_1:'我们可能会适时对本隐私权进行更新。当相关条款发生变更时，我们会在你登录及版本更新时以网站公示、推送通知、弹窗的形式向你展示变更后的隐私权政策。  一旦您继续使用鼎捷服务，将被视为对更新后的隐私权政策的接受和认可。',
    policyItem13:'十三、我们的联系方式',
    policyItem13_1:'如您对本隐私权政策或对本隐私权政策的实践以及操作上有任何疑问和意见，可通过鼎捷的客户隐私专用邮箱 （privacy@digiwincloud.com）与我们联系。',
    policyItem13_2:'如您对我们的回复不满意，特别是您认为我们的用户信息处理行为损害了您的合法权益，您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。',

    policyUserTitle:'鼎捷云管家用户使用协议',
    policyUserContent:'欢迎阅读以下《鼎捷云管家用户使用协议》（以下简称“本协议”）。本协议内容包括协议正文及所有通过“鼎捷云管家”已经发布的或未来可能发布的各项服务对应的服务协议、使用规则、结算规则、法律声明等，均构成本协议的组成部分，与本协议具有同等法律效力。',
    policyUserContent1:'本协议是您与鼎捷数智股份有限公司及其关联方（以下简称“鼎捷数智”或“我们”）之间关于您使用“鼎捷云管家”所订立的条款。为使用“鼎捷云管家”，服务使用人（以下简称“用户”或“您”）应当阅读并遵守本协议，请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款。',
    policyUserContent2:'您确认，您是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织（以下简称“法律主体”）， 如您代表一家公司或其他法律主体进行注册或以其他允许的方式实际使用本服务，视为您已经获得该公司或该法律主体授权同意受本协议条款的约束。',
    policyUserContent3:'如果您不具备前述法律主体资格，请立即终止注册程序及在鼎捷云管家上的任何操作，且“鼎捷云管家”有权注销您的账号。',
    policyUserContent4:'“鼎捷云管家”因此受到损失的，将向您和/或您的监护人索赔。',
    policyUserContent5:'您同意并接受《鼎捷云管家用户使用协议》后才能正式进入“鼎捷云管家”在线申请程序，',
    policyUserContent6:'当您按照页面提示同意本协议，表示您同意接受本协议。否则，请您退出。',
    policyUserItem01:'一、 定义',
    policyUserItem01_1:'1.1. 鼎捷云管家的具体内容由鼎捷数智根据实际情况提供，鼎捷数智及鼎捷云管家有权对其提供的服务或产品形态进行升级或其他调整，并将及时告知您。',
    policyUserItem01_2:'1.2. 鼎捷云管家仅提供与服务相关的技术支持，除此之外与相关网络服务有关的设备（如个人电脑、手机、及其他与接入互联网或移动网有关的装置） 及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由您自行负担。',
    policyUserItem02:'二、 鼎捷云管家的使用',
    policyUserItem02_1:'2.1 鼎捷云管家针对某些特定服务的使用通过各种方式（包括但不限于网页公告、系统通知、私信、短信提醒等）作出的任何声明、通知、 警示等内容视为本协议的一部分，您如使用该等服务，视为您同意该等声明、通知、警示的内容。',
    policyUserItem02_2:'2.2 您承诺自己在使用鼎捷云管家的所有行为均遵守国家法律、法规和本网站的相关规定以及各种社会公共利益或公共道德。 对于任何法律后果的发生，您将以自己的名义独立承担所有相应的法律责任，鼎捷云管家不承担任何责任。',
    policyUserItem02_3:'2.3 您在使用服务时如发现服务系统或其他相关系统的信息安全漏洞需及时通知鼎捷云管家， 禁止对鼎捷云管家系统进行漏洞扫描、渗透测试等可能造成鼎捷云管家损失的行为。',
    policyUserItem02_4:'2.4 除非法律允许或鼎捷数智书面许可，你使用本产品或服务过程中不得从事下列行为：',
    policyUserItem02_41:'2.4.1 删除本产品及其副本上关于著作权的信息；',
    policyUserItem02_42:'2.4.2 对鼎捷数智拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；',
    policyUserItem02_43:'2.4.3 对本产品或者本产品运行过程中释放到任何终端内存中的数据、产品运行过程中客户端与服务器端的交互数据，以及本产品运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、 外挂或非经鼎捷数智授权的第三方工具/服务接入本产品和相关系统；',
    policyUserItem02_44:'2.4.4 通过修改或伪造产品运行中的指令、数据，增加、删减、变动产品的功能或运行效果，或者将用于上述用途的产品、 方法进行运营或向公众传播，无论这些行为是否为商业目的；',
    policyUserItem02_45:'2.4.5 自行或者授权他人、第三方产品对本产品及其组件、模块、数据进行干扰；',
    policyUserItem02_46:'2.4.6 其他未经鼎捷数智或鼎捷云管家明示授权的行为。',
    policyUserItem02_5:'2.5 您的网络和连接。除双方另有书面约定外，您应（a）确保用户方网络和系统符合我们随时提供的相关规范（如有）； （b）全权负责采购和维护从您的系统到我们或任何第三方数据中心的网络连接和电信连接；并且 （c）自行承担所有因您的网络连接、电信连接或因互联网引起的或与之相关的所有问题、条件、延迟、 交付失败和所有其他损失、损坏、责任、费用或任何性质或种类的费用。',
    policyUserItem02_6:'2.6 账号',
    policyUserItem02_61:'（1） 用户使用“鼎捷云管家”，需注册一个账号。',
    policyUserItem02_62:'该账号是用户用来管理“鼎捷云管家”身份的凭据。账号的所有权归“鼎捷云管家”所有，用户完成申请注册手续后， 仅获得该账号的使用权，且该使用权仅属于初始申请注册人。同时，初始申请注册人不得赠与、借用、租用、 转让或售卖账号或者以其他方式许可非初始申请注册人使用账号。非初始申请注册人不得通过受赠、继承、承租、 受让或者其他任何方式使用账号。',
    policyUserItem02_63:'（2）为了创建账号，用户有义务在注册时提供用户名、密码、以及一些必要的资料信息，例如： 企业名称、注册地址、联系人姓名、手机、邮箱及其身份信息等，用户需要保证其真实性、有效性及安全性。 如用户提供的资料信息有任何变动，用户应及时更新。',
    policyUserItem02_64:'（3）用户申请并创建成功账号后，用户不得将账号信息透露给任何其他人，用户自行负责自己账号的保密和安全， 并对用户的账号发生的或通过用户的账号发生的一切活动负全责。用户应当使用由字母、数字、特殊字符组成的密码（最好８位以上长度）， 并应定期更改密码。当用户使用完毕后，应安全退出。因用户保管不善可能导致遭受盗号或密码失窃，责任由用户自行承担。',
    policyUserItem02_65:'（4）实名认证。',
    policyUserItem02_66:'鼎捷数智和您应遵守相关法律法规进行实名认证。',
    policyUserItem02_67:'就某些鼎捷云管家服务的开通，鼎捷云管家可能要求您提供进一步的身份资料、经营资质和信息，以完成身份认证或资格验证。 仅在完成相应身份认证及资格验证后，您才可以订购及使用相关云服务。您理解并同意鼎捷云管家有权自行或委托第三方， 审查您在实名认证时提供的信息是否真实、准确及有效。',
    policyUserItem02_68:'知晓并同意，如您未依照相关法律法规及鼎捷云管家的要求完成实名认证，您将无法订购鼎捷云管家商品，也将影响您访问鼎捷云管家某些服务。',
    policyUserItem02_7:'2.7 订购、使用商品和服务。',
    policyUserItem02_70:'您可以根据需要自行决定购买及使用鼎捷云管家提供的商品或服务。在进行上述行为时，请审慎了解其功能、要求、 收费及退费规则等详细内容，如果您对具体商品或服务有异议，则请勿以任何方式购买及使用。',
    policyUserItem02_71:'2.7.1 费用。',
    policyUserItem02_72:'您应当按照您提交的商品或服务订单中约定的价格及支付方式付款。因您履行本协议所发生的银行费用及与支付有关的 其它费用由您独自承担。在“鼎捷云管家”中提供的商品或服务若涉及到金额及费用，若未特别标注者，皆以人民币作为交易币别。',
    policyUserItem02_73:'2.7.2 发票开具。',
    policyUserItem02_74:'您在鼎捷云管家购买商品或服务后，如需发票等支付凭证或者服务单据的，您应当向鼎捷云管家提出， 并由鼎捷数智股份有限公司或者关联方依法向您开具相应的发票等支付凭证或者服务单据。',
    policyUserItem03:'三、 安全与隐私',
    policyUserItem03_1:'3.1 安全。',
    policyUserItem03_11:'鼎捷云管家会采取技术措施和其他必要措施保鼎捷云管家本身的网络安全和稳定运行。',
    policyUserItem03_2:'3.2 鼎捷云管家隐私保护。',
    policyUserItem03_21:'就您使用鼎捷云管家过程中向鼎捷云管家提供的个人信息，包括但不限于您的姓名、电子邮箱、 联系电话和银行账户信息，鼎捷云管家将严格遵守相关法律法规及＜鼎捷隐私政策＞声明的要求保护您的信息。',
    policyUserItem04:'四、数据安全与保密',
    policyUserItem04_1:'4.1 本服务所称之机密资料，系指由用户透过云服务揭露之所有数据。该数据资料包含但不限于： 产品规格、制程、电路图、线路图、计划、设计、产品、特殊诀窍、计算机程序、程序码、技术图示以及其他商业上、 经济上或技术上的资料、记录、信息等。',
    policyUserItem04_2:'4.2 具有以下的状况时，则该数据资料即不属于机密资料：',
    policyUserItem04_21:'(1) 非可归责于鼎捷云管家之事由而成为众所周知的资料者；',
    policyUserItem04_22:'(2) 在用户方将机密资料揭露予鼎捷云管家之前，鼎捷云管家或鼎捷数智已知悉该资料。',
    policyUserItem04_3:'4.3 鼎捷云管家同意遵守以下的规定并承担保密义务：',
    policyUserItem04_31:'4.3.1 鼎捷云管家不得将机密资料揭露予任何第三人。在例外情形之下，鼎捷数智虽可将机密资料揭露予其员工、关系企业或承包商，但仅以有必要者为限，并且鼎捷数智必须将该资料具有机密性质之情形对其员工、关系企业或承包商严正告诫，并同时须保证其员工、关系企业或承包商将遵守本使用协议之各项规定。',
    policyUserItem04_32:'4.3.2 鼎捷云管家只能基于特定目的而使用机密资料，并且鼎捷云管家应按照其保护自己具有机密性之资料的注意程度而对于用户的机密资料加以保密；但无论如何，鼎捷云管家的注意程度不可低于合理的标准。',
    policyUserItem04_33:'4.3.3 用户有权随时要求鼎捷归还该机密资料。',
    policyUserItem04_34:'4.3.4 在以下情形，鼎捷云管家揭露机密资料的行为，并不违反本协议之保密义务：',
    policyUserItem04_341:'(1) 鼎捷云管家依法律规定或法院命令而不得不揭露机密资料。',
    policyUserItem04_342:'(2) 鼎捷云管家取得用户的事前同意。',
    policyUserItem04_4:'4.4 鼎捷云管家承诺在有任何用户资料因服务器储存设备损坏时以最快的速度从最近的备份中恢复资料，但无法承诺100％的资料恢复。鼎捷云管家将全力确保用户资料安全，鼎捷云管家对于非由鼎捷云管家故意或重大过失导致的用户资料遗失或泄露不承担任何附带、间接、惩罚性、特殊的责任，除非法律或有权机关另有规定。',
    policyUserItem05:'五、知识产权',
    policyUserItem05_1:'5.1 鼎捷知识产权。',
    policyUserItem05_11:'鼎捷数智对鼎捷云管家的商号、商标、域名、图案标示、标志、标识等归属于鼎捷数智或识别鼎捷数智的所有信息享有知识产权。 未经鼎捷数智书面许可，在任何情况下，您不得自行或指示第三方使用、复制这些信息或使用这些信息进行再造、创造与这些内容有关的派生作品。',
    policyUserItem05_2:'5.2 您的内容。',
    policyUserItem05_21:'您在鼎捷云管家发布的各类信息，包括但不限于您对商品或服务的评论，您应确保您的内容不违反本协议的条款和条件并且符合法律法规。 您应对您的内容的合法性、准确性、完整性和可靠性负责。除非法律另有明确规定，否则我们不承担任何与您的内容有关的义务和责任。',
    policyUserItem05_22:'您授予鼎捷云管家托管、处理和/或传输您的内容以运行和提供服务的权利，但涉及您的个人信息的、 或您在发布内容的同时声明全部或部分保留的，该等使用行为不得违反国家隐私保护法规的规定，或超出您声明保留的范围。',
    policyUserItem06:'六、责任限制',
    policyUserItem06_1:'6.1 责任限制。',
    policyUserItem06_11:'无论是否有其他协议约定，我们就我们或我们的任何关联方在本协议项下的因合同、虚假陈述（不论是侵权的还是法定的）、侵权行为（包括疏忽）和违反法定责任或其他原因所造成的任何性质或种类的损失、损害、罚款、责任、收费、诉讼、费用、 支出或成本的最大赔偿责任不应超过在该责任产生前十二（12）个月期间您就导致索赔的服务实际支付给鼎捷云管家的费用金额。',
    policyUserItem06_2:'6.2 平台运营风险',
    policyUserItem06_21:'您理解并同意，尽管鼎捷云管家及鼎捷数智采取了必要措施维护鼎捷云管家的正常运营， 但依然可能出现下述问题，您同意因下述问题给您带来的损失，鼎捷云管家及鼎捷数智免责：',
    policyUserItem06_22:'（1）鼎捷云管家及鼎捷数智在进行网络调整和维护时进行的服务中断；',
    policyUserItem06_23:'（2）由于网络上通路的阻塞造成您对商品或服务访问速度下降；',
    policyUserItem06_24:'（3）因黑客、计算机病毒、木马或其他恶意程序造成；',
    policyUserItem06_25:'（4）因电信部门技术调整和骨干线路中断造成；',
    policyUserItem06_26:'（5）因故障处理的操作维护，包含但不限于故障处理、系统升级、系统调优扩容等导致；',
    policyUserItem06_27:'（6）因您操作不当或您的电脑软件、系统、硬件和通信线路的问题引起；',
    policyUserItem06_28:'（7）因您违反鼎捷云管家的使用规则使用相关服务引起；',
    policyUserItem06_29:'（8）其他非鼎捷云管家及鼎捷数智过错导致的问题。',
    policyUserItem06_3:'6.3 仅直接损失：在法律允许的范围内，在任何情况下，鼎捷数智或其关联公司均不对任何间接、附带、特殊、后果性、 惩戒性损害（包括但不限于损失收入、利润、机会、客户、商誉、声誉、数据或数据使用）负责，即使鼎捷数智已被告知该等损害发生的可能性。',
    policyUserItem07:'七、期限、暂停与终止',
    policyUserItem07_1:'7.1 生效。本协议期限自本协议规定生效日期起生效，除非根据本协议终止，本协议将持续有效。',
    policyUserItem07_2:'7.2 暂停。在下列情况下，我们可能会暂停您访问或使用鼎捷云管家的权利：',
    policyUserItem07_21:'（1）您在访问和使用鼎捷云管家时违反了可接受的使用政策、本协议或适用的法律法规;',
    policyUserItem07_22:'（2）您违反了您向鼎捷云管家的付款义务;',
    policyUserItem07_23:'（3）您的访问和对鼎捷云管家的使用可能会对鼎捷云管家、我们或第三方造成安全风险;',
    policyUserItem07_24:'（4）您对鼎捷云管家的使用可能会对鼎捷云管家的功能、可用性或操作产生不利影响;',
    policyUserItem07_25:'（5）根据相关法律法规或政府机构的要求;',
    policyUserItem07_26:'（6）您对鼎捷云管家的使用可能使鼎捷云管家承担责任或监管合规风险;',
    policyUserItem07_27:'（7）您可能侵犯第三方的知识产权;或',
    policyUserItem07_28:'（8）您已停止正常营业、或已破产、清盘、解散或类似程序中。 您承认并同意（a）暂停不会免除您就暂停期之前及暂停期间的服务费进行支付的义务; （b）您将无权因此类暂停得到任何退款或服务费用减免。',
    policyUserItem07_3:'7.3 终止。如果出现第8.2（1）至（8）节中描述的任何情况，我们也保留终止您访问和使用鼎捷云管家的权利。',
    policyUserItem08:'八、全部协议',
    policyUserItem08_1:'8.1 协议关系。您在鼎捷云管家注册账户时，已接受《鼎捷云管家用户协议》。就您使用以鼎捷云管家名义提供的云服务时，适用鼎捷云管家用户协议。',
    policyUserItem08_2:'8.2 完整协议。本协议包括本协议的条款和条件，及以援引方式纳入本协议的政策和文件。',
    policyUserItem08_3:'8.3 协议修改。鼎捷云管家保留修改本协议任何条款的权利，一旦本协议的内容发生变动，您可以在相关服务页面查阅最新版本的协议条款， 修改后的条款一经公布立即生效，鼎捷云管家无需单独通知您。若您不同意上述修改，则可以选择停止使用服务。 鼎捷云管家也可选择通过其他适当方式（比如系统通知）向您通知修改内容,,如果不同意鼎捷云管家对本协议相关条款所做的修改， 您有权停止使用服务。如果您继续使用服务，则视为您接受鼎捷云管家对本协议相关条款所做的修改。',
    policyUserItem09:'九、通知送达',
    policyUserItem09_1:'9.1 本协议项下鼎捷云管家对于您所有的通知均可通过网页公告、电子邮件、系统通知主动联系、私信、 手机短信或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。',
    policyUserItem09_2:'9.2 您对于鼎捷云管家的通知应当通过鼎捷云管家对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。',
    policyUserItem10:'十、其他规定',
    policyUserItem10_1:'10.1 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。',
    policyUserItem10_2:'10.2 本协议中的标题仅为方便而设，在解释本协议时应被忽略。',
    policyUserItem11:'十一、法律适用',
    policyUserItem11_1:'11.1 本协议及其修订本的有效性、履行和解释均适用于中华人民共和国之法律，任何争议也仅适用中华人民共和国法律。',
    policyUserItem11_2:'11.2 因本协议所引起的您与鼎捷数智的任何纠纷或争议，首先应本着友好协商原则进行解决，如果协商不成的， 您在此完全同意将纠纷或争议提交至鼎捷数智股份有限公司注册地有管辖权的人民法院通过诉讼解决。',
    policyUserItem12:'十二、附则',
    policyUserItem12_1:'12.1 关系。双方均为独立缔约方。本协议不为双方创立合伙、合资、代理或雇佣关系。',
    policyUserItem12_2:'12.2 无第三方受益人。除非本协议另有明确规定，非本协议当事人不得执行本协议项下的任何条款。',
    policyUserItem12_3:'12.3 通知。我们可依照本协议规定通过网站、邮箱、短信向您发出通知。我们通过网站而发出的通知将在发布后生效， 通过电子邮件发布的通知将在我们发出电子邮件时生效（无论您是否接收或读取它），短信在发出时生效。您有责任及时更新您的邮箱地址或电话号码。',
    policyUserItem12_4:'12.4 不弃权。未能执行本协议的任何条款并不构成对此条款的放弃，亦不限制以后执行该等条款的权利。 如果一方放弃追究任何一条违反本协议要求的条款，不得视为放弃以后追究违反该条款的权利，也不得视为放弃追究违反任何其他条款的权利。',
    policyUserItem12_5:'12.5 可分割性。如果本协议任何条款被认定为无效或不可执行，本协议的其他条款将继续有效。 任何无效或不可执行的条款将被替换为与本协议目的和意图一致的另一条款。',
    policyUserItem12_6:'12.6 不可转让。未经鼎捷数智事先书面同意，您不得转让或以其他方式将本协议的全部或部分转让给任何第三方，包括您的关联方。 鼎捷数智可能会在未经您同意的情况下向我们的关联方转让或转移本协议项下的任何权利或义务。在转让生效前，我们会通过网站通知或其他途径告知您。',
}
export default zh_CN
